import React, { Fragment, useState } from 'react'
import {Boton} from './Boton.jsx'
import {Data} from './Data.jsx'
import { Link } from 'react-router-dom'

export const Inicio = () => {

  const [clicked, setClicked] = useState(false);
  
  
  const handleClick = () => {
    //Cuando está true lo pasa a false y viceversa.
    setClicked(!clicked);
  }


  const [categoriaSeleccionadas, setcategoriaSeleccionadas] = useState ('');
  const [talleSeleccionados, setTalleSeleccionados] = useState('');

  const handleOnCheckbox = (e) => {
    const { name, value, checked } = e.target;
    
    // Verifica combinaciones 
    const combinacionSinStock = (categoriaSeleccionadas.includes('LISAS') && value === 'L' && checked) || (name === 'ropa' && value === 'LISAS' && talleSeleccionados.includes('L'));
    const combinacionSinStock2 = (categoriaSeleccionadas.includes('SKATERS') && value === 'L' && checked) || (name === 'ropa' && value === 'SKATERS' && talleSeleccionados.includes('L'));
    const combinacionSinStock3 = (categoriaSeleccionadas.includes('VINTAGE') && value === 'L' && checked) || (name === 'ropa' && value === 'VINTAGE' && talleSeleccionados.includes('L'));
    const combinacionSinStock4 = (categoriaSeleccionadas.includes('SHORT') && value === 'S' && checked) || (name === 'ropa' && value === 'SHORT' && talleSeleccionados.includes('S'));

    if (combinacionSinStock  || combinacionSinStock2  ||  combinacionSinStock3 || combinacionSinStock4) {
      alert('No hay stock disponible en este talle.');
      window.location.reload();
    }

    if (name === 'ropa') {

      if (checked) {
        setcategoriaSeleccionadas([...categoriaSeleccionadas, value]);
      } else {
        setcategoriaSeleccionadas(categoriaSeleccionadas.filter((categoria) => categoria !== value));
      }
    } else if (name === 'talle') {
      
      if (checked) {
        setTalleSeleccionados([...talleSeleccionados, value]);
      } else {
        setTalleSeleccionados(talleSeleccionados.filter((talle) => talle !== value));
      }
    }
  };
  const XimagenesMostrar = Data.filter((imagen) => {
    const tieneCategorias = categoriaSeleccionadas.length === 0 || categoriaSeleccionadas.includes(imagen.category);
    const tieneTalles = talleSeleccionados.length === 0 || talleSeleccionados.includes(imagen.talle);
    return tieneCategorias && tieneTalles;
  });
  return (
    <Fragment>
        <div>
              <div className='boton'>
                  <Boton clicked={clicked} handleClick={handleClick}  />
               </div>
          
              <div className={clicked ? 'contenedor-lista2' : 'contenedor-lista'}>
              
                  <h2 className='filx'> Filtros </h2>
             
                  <div >
                    
                    <input onChange={handleOnCheckbox}
                          type='checkbox' 
                          name='ropa'
                          value='LISAS'
                          id='LISAS'
                          precio='precio'
                          />
                          <label htmlFor='LISAS'> LISAS </label>
                  </div> 
                  <div >
                    
                    <input onChange={handleOnCheckbox}
                          type='checkbox' 
                          name='ropa'
                          value='SKATERS'
                          id='SKATERS'
                          precio='precio'
                          />
                          <label htmlFor='SKATERS'> SKATERS </label>
                  </div> 
                  <div >
                    <input onChange={handleOnCheckbox}
                          type='checkbox' 
                          name='ropa'
                          value='VINTAGE'
                          id='VINTAGE'
                          precio='precio'
                          />
                          <label htmlFor='VINTAGE'> VINTAGE </label>
                  </div> 

                  <div >
                    <input onChange={handleOnCheckbox}
                          type='checkbox' 
                          name='ropa'
                          value='SHORT'
                          id='SHORT'
                          precio='precio'
                          />
                          <label htmlFor=' SHORT'> SHORT </label>
                  </div> 

                  <h2 className='filx'>Talles </h2>
                  <div >
                    <input onChange={handleOnCheckbox}
                          type='checkbox' 
                          name='talle'
                          value='S'
                          id='S'
                          precio='precio'
                          />
                          <label htmlFor='S'> S </label>
                  </div> 
              
                  <div>
                    <input onChange={handleOnCheckbox}
                          type='checkbox' 
                          name='talle'
                          value='L'
                          id='L'
                          precio='precio'
                          />
                          <label htmlFor='L'> L </label>
                    
                  </div> 
                
              </div>
         
            <div className='ropa'>
              {XimagenesMostrar.map((imagen) => (
                <div key={imagen.id}>
                   <Link to="/Comprar">
                      <img src={imagen.image} alt={imagen.category} />
                   </Link>
                  <div className='izquierda'>{imagen.precio}</div>
                </div>
              ))}
            </div>
        
      </div>   
     
  </Fragment>
  )
}